// extracted by mini-css-extract-plugin
export default {"onPremiseCreation":"style_onPremiseCreation__+dB8h","showPointerOnStep":"style_showPointerOnStep__gLOnS"};